'use strict';
'use es6';

/**
 * @param {ReactElement} node
 * @param {RegExp} regex
 * @returns {Boolean} - true if the node has a displayName that matches the given regex
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var nodeDisplayNameMatches = exports.nodeDisplayNameMatches = function nodeDisplayNameMatches(node, regex) {
  return !!(node && node.type && node.type.displayName && node.type.displayName.match(regex));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/core/ReactNodes.js
// module id = 447
// module chunks = 0